import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Typography } from '@mui/material';
import { meetingsAPI } from '../../services/api';
import PageBackButton from '../../components/PageBackButton';
import StaffMeetingList from './StaffMeetingList';
import { buildMeetingListParams, olderArchiveToYmd, unwrapMeetingsResponse } from './meetingListUtils';

function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

const MyMeetings = () => {
  const [range, setRange] = useState('recent');
  const [search, setSearch] = useState('');
  const [archiveFrom, setArchiveFrom] = useState('');
  const [archiveTo, setArchiveTo] = useState(olderArchiveToYmd());
  const [page, setPage] = useState(1);
  const searchDebounced = useDebouncedValue(search);

  const listParams = useMemo(
    () => buildMeetingListParams({ range, search: searchDebounced, archiveFrom, archiveTo, page }),
    [range, searchDebounced, archiveFrom, archiveTo, page]
  );

  const query = useQuery(['my-meetings', listParams], () =>
    meetingsAPI.mine(listParams).then((res) => unwrapMeetingsResponse(res))
  );

  return (
    <Box>
      <PageBackButton />
      <Typography variant="h5" sx={{ mb: 1 }}>
        My meetings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Meetings assigned to you. Open the join link when it is time.
      </Typography>
      <StaffMeetingList
        meetings={query.data?.rows || []}
        pagination={query.data?.pagination}
        loading={query.isLoading}
        range={range}
        onRangeChange={(next) => {
          setRange(next);
          setPage(1);
        }}
        search={search}
        onSearchChange={(value) => {
          setSearch(value);
          setPage(1);
        }}
        archiveFrom={archiveFrom}
        archiveTo={archiveTo}
        onArchiveFromChange={(value) => {
          setArchiveFrom(value);
          setPage(1);
        }}
        onArchiveToChange={(value) => {
          setArchiveTo(value);
          setPage(1);
        }}
        onPageChange={setPage}
        variant="mine"
      />
    </Box>
  );
};

export default MyMeetings;
